<template>
	<div class="display-flex flex-column">
		<h2 class="reg">Apps I use</h2>
		<h3 class="subtitle reg">Tailor your experience in the marketplace and in the builder. Help us prioritize support for integrations</h3>
		<span>
			<h5 class="subtitle">
				<SIcon class="mr-1" name="private-and-secure" :width="11" :height="15" />
				This list is only used for your experience in Ply, we do not sell your data. It’s always
				<a class="subtitle" href="https://info.ply.io/privacy" target="_blank">private and secure</a>.
			</h5>
		</span>
	</div>
</template>
<script>
export default { name: 'ManageAppsHeaderExplanations' };
</script>
<style scoped lang="scss">
.subtitle {
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-weight: 300;
}
</style>
